import axios from '../index';

export const requestGetPatientStatusesById = ({ patientId } = {}) =>
  axios.get(`/fhir/QuestionnaireResponse`, {
    params: {
      patient: patientId,
      questionnaire: 'resource-statuses',
    },
  });
